import {store} from '../../redux/store';
import {hideSpecialityModal, showSpecialityModal} from './reducer';

/**
 * Dispatches an action to show the global Speciality modal with the provided data.
 * @function
 * @returns {void}
 */
export const openSpecialityModal = () => {
  store.dispatch(showSpecialityModal());
};

/**
 * Dispatches an action to close the global Speciality modal.
 * @function
 * @returns {void}
 */
export const closeSpecialityModal = () => {
  store.dispatch(hideSpecialityModal());
};

/**
 * Dispatches an action to toggle the global Speciality modal.
 * @function
 * @returns {void}
 */
export const toggleSpecialityModal = () => {
  const {isVisible} = store.getState().specialityModal;
  if (isVisible) {
    store.dispatch(hideSpecialityModal());
  } else {
    store.dispatch(showSpecialityModal());
  }
};
